import md5 from 'blueimp-md5'
import QRCode from 'qrcode.react'
import React, { createRef, useEffect, useState } from 'react'

import { Button, Card, CardMedia, CircularProgress, Grid, TextField } from '@material-ui/core'

import useStyles from './styles'

import { getPartnersList } from '../../services/ClubeApi'

function AllQrCode() {
  const ref = createRef()
  const classes = useStyles()
  const [unitiesList, setUnitiesList] = useState([])
  const [pagesData, setPagesData] = useState({
    actualPage: 1,
    count: 0
  })
  const [count, setCount] = useState(1)
  const [delimiter, setDelimiter] = useState(0)
  const [perPage, setPerPage] = useState(1000)
  const [pages, setPages] = useState(0)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    getPartnersList().then(r => {
      setIsLoading(false)
      setUnitiesList(
        r
          .map(item => {
            return item.PartnerUnits
          })
          .flat()
          .filter(item => {
            return item.situation === 1 || item.situation === 3
          })
      )
    })
  }, [])

  useEffect(() => {
    setPages(Math.ceil(unitiesList.length / perPage))
  }, [unitiesList, perPage])

  useEffect(() => {
    const value = pagesData.actualPage * perPage - perPage
    setCount(value)
    setDelimiter(value + perPage)
  }, [pagesData, perPage])

  const plusPage = () => {
    if (pagesData.actualPage < pages) {
      setPagesData(item => {
        return { ...item, actualPage: pagesData.actualPage + 1 }
      })
    }
  }

  const lesPage = () => {
    if (pagesData.actualPage > 0) {
      setPagesData(item => {
        return { ...item, actualPage: pagesData.actualPage - 1 }
      })
    }
  }

  const setActualPage = e => {
    let value = e
    if (e < 1) {
      value = 1
    }
    if (e > pages) {
      value = pages
    }

    setPagesData(item => {
      return { ...item, actualPage: value }
    })
  }

  return (
    <>
      <Grid container className="hideOnPrint" displayPrint="none">
        <Grid className="hideOnPrint" item xs={1} style={{ padding: '20px' }}>
          <Button onClick={lesPage} variant="contained" color="primary">
            Anterior
          </Button>
        </Grid>
        <Grid className="hideOnPrint" item xs={3} style={{ padding: '20px' }}>
          <TextField
            id="outlined-basic"
            label="Pagina"
            type="number"
            variant="outlined"
            value={pagesData.actualPage}
            onChange={e => setActualPage(e.target.valueAsNumber)}
          />
          {`  / ${pages}`}
        </Grid>
        <Grid className="hideOnPrint" item xs={2} style={{ padding: '20px' }}>
          <Button onClick={plusPage} variant="contained" color="primary">
            Próxima
          </Button>
        </Grid>
        <Grid className="hideOnPrint" item xs={2} style={{ padding: '20px' }}>
          <TextField
            id="outlined-basic"
            label="Por Pagina"
            type="number"
            variant="outlined"
            value={perPage}
            onChange={e => setPerPage(e.target.valueAsNumber)}
          />
        </Grid>
        {isLoading && (
          <Grid className="hideOnPrint" item xs={2} className={classes.progressArea}>
            <CircularProgress />
          </Grid>
        )}
      </Grid>
      <Grid ref={ref} container spacing={0}>
        {pagesData.actualPage <= pages &&
          unitiesList
            .filter(item => {
              const cities = [
                'São José dos Pinhais',
                'Colombo',
                'Pinhais',
                'Campo Largo',
                'Araucaria',
                'Araucária',
                'Piraquara',
                'São José',
                'Fazenda Rio Grande',
                'Almirante Tamandaré',
                'Campina Grande do Sul',
                'Curitiba',
                'Pontal do Paraná',
                'Paranaguá',
                'SÃO JOSÉ DOS PINHAIS',
                'Matinhos'
              ]
              return cities.includes(item.city)
            })
            .sort((a, b) => (a.fantasyName < b.fantasyName ? -1 : 1))
            .slice(count, delimiter)
            .map((item, index) => (
              <Grid
                style={{
                  width: '57mm',
                  height: '57mm',
                  border: '.5mm solid black',
                  marginTop: index > 5 && index % 24 < 4 ? '2.92cm' : 0
                }}
                key={item.id}
                item
              >
                <Card style={{ width: '57mm', height: '57mm' }}>
                  <CardMedia
                    className={classes.cardMedia}
                    style={{ width: '57mm', height: '57mm', padding: '10px' }}
                  >
                    <style>{`
                      .${classes.cardMedia} svg {
                        width: 100%;
                        height: auto;
                      }
                    `}</style>
                    <QRCode
                      value={`https://clube.gazetadopovo.com.br/?route=${md5(item.id)}`}
                      size={350}
                      renderAs="svg"
                    />
                    <p
                      style={{
                        fontSize: '8px',
                        textAlign: 'center',
                        margin: '10px 0 0'
                      }}
                    >
                      {item.fantasyName} | {item.city}
                    </p>
                  </CardMedia>
                </Card>
              </Grid>
            ))}
      </Grid>
    </>
  )
}

export default AllQrCode
